<template>
    <div>
        <salary-item
            v-for="(item, index) in list"
            :key="index"
            :form="item"
            @delete="handleDelete(item.id, index)"/>
        <el-button
            icon="el-icon-plus"
            type="primary"
            @click="handleAdd">
            {{ $t('Finance.addnewtemplate') }}
        </el-button>
    </div>
</template>

<script>
import SalaryItem from '@/components/widget/Finance/SalaryItem.vue';

export default {
    name: 'Salary',
    components: {
        SalaryItem,
    },
    data() {
        return {
            list: [
                {
                    id: '',
                    name: '',
                    type: 1,
                    baseSalary: 0,
                    countingWay: 0,
                    grades: []
                },
            ],
        };
    },
    watch: {
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.loading = true;
            API.get('finance/salary-template').then(res => {
                if (res.length) {
                    this.list = res.map(el => {
                        el.baseSalary = parseFloat(el.baseSalary);
                        if (!el.grades) return el;
                        for(const i of el.grades) {
                            for (const key of Object.keys(i)) {
                                i[key] = parseFloat(i[key]);
                            }
                        }
                        return el;
                    });
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        handleAdd() {
            this.list.push({
                id: '',
                name: '',
                type: 1,
                baseSalary: 0,
                countingWay: 0,
                grades: []
            });
        },
        handleDelete(id, index) {
            this.loading = true;
            API.delete(`finance/salary-template/${id}`).then(res => {
                this.list.splice(index, 1);
                $ele.$message.success(this.$t('Message.delete_success'));
            }).finally(() => {
                this.loading = false;
            });
        }
    },
};
</script>

<style lang="scss">
</style>
